import React, { useEffect, useMemo } from 'react';
import { browserHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import SiteNav from '../SiteNav';
import ProgressBar from '../ProgressBar';
import EmailForm from '../EmailForm';
// this provider card has been removed
// import ProviderCard from '../Cards/ProviderCard';
import ChangePackageCTA from '../ChangePackageCTA';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';
import { useGetWebleadFromCookie, useDetectWebleadUser } from '../../customHooks';

//fer testin
import { preneedPackagesOperations } from '@evdy/web-redux/dist/lib/webPurchase/preneedPackages';

import styles from './EmailStep.module.scss';

const { getPreneedPackages } = preneedPackagesOperations;

const { 'email-step': emailStepClass, 'step-content': stepContentClass } = styles;

const EmailStep = () => {
  //testing - remove when done
  const { preneedPackages = [], authUser, webleadUser = {}, webleadUpdated = false } = useSelector(
    ({ webPurchase, authUser }) => ({
      authUser,
      preneedPackages: webPurchase.preneedPackages.data?.packages,
      webleadUser: webPurchase.purchaseFlow?.data,
      webleadUpdated: webPurchase?.purchaseFlow?.webleadUpdated
    })
  );
  const dispatch = useDispatch();

  const { _id: loggedInUserId } = authUser?.data ?? {};
  const isLoggedIn = !!loggedInUserId;

  // scroll to top on mount
  useScrollToTop();

  // on mount, if no cookie detected navigate back to all packages
  useDetectWebleadUser();

  // on mount, check if weblead cookie exists and fetch existing weblead
  useGetWebleadFromCookie();

  const userData = useMemo(() => {
    return isLoggedIn ? authUser?.data : webleadUser;
  }, [authUser.data, isLoggedIn, webleadUser]);

  //testing - remove when done
  //get preneed packages
  useEffect(() => {
    if (!preneedPackages?.length) {
      dispatch(getPreneedPackages());
    }
  }, [preneedPackages.length]);

  const handleSubmit = () => {};

  const initialFormData = {
    provider: ''
  };

  const homes = [
    {
      id: '123',
      name: 'Wm. Sullivan & Son Funeral Home',
      profileImage:
        'https://requiem-dashboard-media.s3.amazonaws.com/2020/07/bf8ed689-959e-457a-81e7-8ce8e726513a_pup.jpg',
      preferred: true,
      address: {
        street: '123 Fake Street',
        city: 'Royal Oak',
        state: 'MI',
        zip: '48067'
      },
      ratingsInfo: { average: 0.8 },
      priceListingGPLUrl:
        'https://everdays-home-price-gpl.s3.amazonaws.com/5f22fc031f3a711db5e75f89/5fce37fb581fb437a2b7c374.pdf',
      colors: { color1: '#bc914f', color2: '#efd696', color3: '#fbf2d8' }
    },
    {
      id: '456',
      name: 'This is the other home',
      preferred: false,
      address: {
        street: '115 S Main St',
        city: 'Royal Oak',
        state: 'MI',
        zip: '48067'
      },
      ratingsInfo: { average: 0.2 },
      colors: { color1: '#674d80', color2: '#d5cdd8', color3: '#f3e9fa' }
    }
  ];

  // testing vars
  const packageInfo = preneedPackages.map(({ colors, packageName, packageId }) => ({
    colors,
    packageId,
    name: packageName.director
  }));

  return (
    <div className={emailStepClass}>
      {/* TESTING */}
      <ChangePackageCTA {...{ packageInfo, userData, webleadUpdated }} />
      {/* TESTING */}
      <SiteNav />
      <div className={stepContentClass}>
        <ProgressBar step={1} steps={4} />
        <EmailForm moveToNextStep={() => browserHistory.push('/b/dob')} />
      </div>
      {/* this is not where this goes, its just here until choose provider step is made */}
      <Formik onSubmit={handleSubmit} initialValues={initialFormData}>
        {({ values }) => (
          <Form>
            {homes.map((home, idx) => (
              // <ProviderCard
              //   key={home.id}
              //   {...home}
              //   value={values.provider}
              //   title={idx === 0 && 'Most Loved Near You'}
              // />
              <></>
            ))}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default EmailStep;
